import { module as modujs } from "modujs";
import { gsap } from "gsap";

export default class extends modujs {
  constructor(m) {
    super(m);

		this.isPlaying = false

    this.events = {
			click: {
        preview: "onToggleVideo"
      },
      mouseenter: {
        inner: "onMouseEnter"
      },
      mouseleave: {
        inner: "onMouseLeave"
      },
    }
  }

  init() {
    this.paths = Array.from(this.$('path'))
    this.sound = this.$('sound')
    this.videoPreview = this.$('preview')
    this.caption = this.$('caption')
    this.videoFull = this.$('full')

		this.videoFull[0].addEventListener("ended", () => {
			this.stopVideo()
		})

		gsap.set(this.paths, { opacity: 0 })
  }

  onMouseEnter() {
    this.soundTl = gsap.timeline( {repeat: -1} )
    
    this.soundTl.to(this.paths, { 
      opacity: 1, 
      stagger: 0.1, 
      ease: "linear",
      duration: 0.9,
    })
  }

  onMouseLeave() {
    if (this.soundTl) {
      this.soundTl.kill()
    }
    
    gsap.to(this.paths, { 
      opacity: 0, 
      ease: "linear",
      duration: 0.3
    })
  }

	playVideo() {
		gsap.to(this.sound, { opacity: 0, ease: "linear" })
		
		if(this.videoPreview) {
			gsap.to(this.videoPreview, { opacity: 0, ease: "linear" })
		}

		this.videoFull[0].currentTime = 0
		this.videoFull[0].play()
		this.isPlaying = true
	}

	stopVideo() {
		gsap.to(this.sound, { opacity: 1, ease: "linear" })
		
		if(this.videoPreview) {
			gsap.to(this.videoPreview, { opacity: 1, ease: "linear" })
		}

		this.videoFull[0].pause()
		this.isPlaying = false
	}

	onToggleVideo() {
		if(!this.isPlaying) {
			this.playVideo()
		}
		else {
			this.stopVideo()
		}
	}

  destroy() {
    if (this.soundTl) {
      this.soundTl.kill()
    }
  }
}